import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toPng } from 'html-to-image';
import QRCode from 'react-qr-code';
import { StepIndicator } from '../components/StepIndicator';
import '../styles/jobApplicationSuccess.scss';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const JobApplicationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const [requiredDocuments, setRequiredDocuments] = useState([]);

  const referenceNumber = location.state?.referenceNumber;

  useEffect(() => {
    if (!referenceNumber) {
      navigate('/', { replace: true });
    }
  }, [referenceNumber, navigate]);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/website/content`);
        if (!res.ok) return;
        const json = await res.json();
        if (Array.isArray(json.requiredDocuments)) {
          setRequiredDocuments(json.requiredDocuments);
        }
      } catch (err) {
        // Non-critical — the page still works without this list
      }
    };
    fetchDocuments();
  }, []);

  if (!referenceNumber) return null;

  const qrValue = `${window.location.origin}/track/${referenceNumber}`;

  const handleSaveAsImage = async () => {
    if (!cardRef.current) return;
    setIsSaving(true);
    try {
      const dataUrl = await toPng(cardRef.current, { pixelRatio: 2 });
      const link = document.createElement('a');
      link.download = `${referenceNumber}.png`;
      link.href = dataUrl;
      link.click();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="success-page">
      <div className="success-container">
        <StepIndicator currentStep={3} />

        <div className="success-icon">✓</div>
        <h1>تم إرسال طلبك بنجاح</h1>
        <p className="success-text">
          شكرًا لتقديمك على الوظيفة. يمكنك استخدام الرقم المرجعي أو رمز QR أدناه لمتابعة
          حالة طلبك لاحقًا.
        </p>

        <div className="reference-card" ref={cardRef}>
          <span className="reference-card__label">الرقم المرجعي</span>
          <span className="reference-card__value" dir="ltr">
            {referenceNumber}
          </span>
          <div className="reference-card__qr">
            <QRCode value={qrValue} size={160} />
          </div>
        </div>

        <button
          type="button"
          className="save-btn"
          onClick={handleSaveAsImage}
          disabled={isSaving}
        >
          {isSaving ? 'جارٍ الحفظ...' : 'حفظ كصورة'}
        </button>

        {requiredDocuments.length > 0 && (
          <div className="documents-box">
            <h2>المستندات المطلوبة عند الحضور</h2>
            <ul>
              {requiredDocuments.map((doc, index) => (
                <li key={index}>{doc}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobApplicationSuccess;
